import { AbstractControl, AsyncValidatorFn, ValidatorFn } from "@angular/forms";
import { Injector } from "@angular/core";
import { of } from "rxjs";
import { map } from "rxjs/operators";

import { ValidatorFactory } from "../../interface/validator-factory.interface";
import { AsyncValidationError } from "../../interface/type/async-validation-error.type";
import { SyncValidationError } from "../../interface/type/sync-validation-error.type";
import { LoggingService } from "../../service/logging.service";
import { CampaignZoneService } from "../../service/campaign-zone.service";
import { CampaignService } from "../../service/campaign.service";
import { Logger } from "../logger.model";
import { HolidayType } from "../../persistence/dto/holiday-type.enum";
import { CampaignZone } from "../../persistence/dto/campaign-zone.model";
import { flatMap } from "../operator/flat-map.operator";

	/**
	 * @description
	 *  Validador que permite evitar la creación de un día no-laboral cuando
	 *	hay zonas disponibles activas en dicho día.
	 */

export class HolidayEditCrossValidator implements ValidatorFactory {

	private campaignService: CampaignService;
	private campaignZoneService: CampaignZoneService;
	private logger: Logger;

	constructor(private injector: Injector) {
		this.campaignService = this.injector.get(CampaignService);
		this.campaignZoneService = this.injector.get(CampaignZoneService);
		this.logger = this.injector
			.get(LoggingService)
			.getLogger("holiday-edit.cross.validator");
	}

	/**
	 * TODO: Mejorar para que soporte campañas solapadas.
	 */
	public asyncValidator(control: AbstractControl): AsyncValidationError {
		const holidayType: HolidayType = control.get("type").value;
		const holidayDate: Date = new Date(control.get("date").value);
		if (holidayType !== HolidayType.Holiday) {
			return of(null);
		}
		else {
			const holidayString: string = holidayDate.toLocaleDateString();
			return this.campaignService
				.campaignsByYear(holidayDate.getFullYear())
				.pipe(
					map(campaigns => campaigns
						.filter(campaign => campaign.contains(holidayDate))
						.slice(0, 1)),
					flatMap(campaigns => {
						if (0 < campaigns.length) {
							return this.campaignZoneService.allZones(campaigns[0].id)
						}
						else {
							return of([] as CampaignZone[]);
						}
					}),
					map(campaignZones => campaignZones
						.filter(campaignZone => holidayString === campaignZone.dateCC.toLocaleDateString()
							|| holidayString === campaignZone.dateMain.toLocaleDateString())),
					map(campaignZones => {
						if (0 < campaignZones.length) {
							this.logger.debug("Zone overlapping detected:", campaignZones);
							const zones: string = campaignZones
								.map(campaignZone => campaignZone.zonaId)
								.sort()
								.join(", ");
							return {
								overlap: {
									count: campaignZones.length,
									zones: zones
								}
							};
						}
						else {
							return null;
						}
					})
				);
		}
	}

	public asyncValidators(): AsyncValidatorFn[] {
		return [
			this.asyncValidator.bind(this)
		];
	}

	public validator(control: AbstractControl): SyncValidationError {
		return null;
	}

	public validators(): ValidatorFn[] {
		return [
			this.validator.bind(this)
		];
	}
}
